export const types = {
    ERROR_REQUESTING_PREQUAL: 'ERROR_REQUESTING_PREQUAL',
    RECEIVED_PREQUAL: 'RECEIVED_PREQUAL',
    REQUEST_PREQUAL: 'REQUEST_PREQUAL'
};

export const errorRequestingPrequal = (error) => ({
    payload: {
        error
    },
    type: types.ERROR_REQUESTING_PREQUAL
});

export const receivedPrequal = (prequal) => ({
    payload: {
        prequal
    },
    type: types.RECEIVED_PREQUAL
});

export const requestPrequal = (form, request, promise) => ({
    payload: {
        form,
        request,
        promise
    },
    type: types.REQUEST_PREQUAL
});



// WEBPACK FOOTER //
// ./src/actions/prequal.js